import React, { Component } from 'react';

import withStyles from '@mui/styles/withStyles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Input from '@mui/material/Input';

import { calculatePhoneNumberChange } from '../utils/utils';

import phoneInputStyle from '../assets/jss/crm/components/phoneInputStyle.jsx';

class PhoneInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Mobile: false,
      Home: false,
      Work: false,
      Business: false,
      Fax: false,
      number: '',
    };
  }

  componentDidMount() {
    this.populateStateFromProps();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.number !== prevProps.number ||
      this.props.actualRoles !== prevProps.actualRoles ||
      this.props.possibleRoles !== prevProps.possibleRoles
    ) {
      this.populateStateFromProps();
    }
  }

  populateStateFromProps() {
    const { possibleRoles, actualRoles, number } = this.props;
    this.setState({ number });
    possibleRoles.forEach((possibleRoleName) => {
      const isActual = actualRoles.indexOf(possibleRoleName) >= 0;
      this.setState({ [possibleRoleName]: isActual });
    });
  }

  handleCheckboxChange(event) {
    this.setState({ [event.target.name]: event.target.checked }, this.reportCheckboxChange);
  }

  reportCheckboxChange() {
    this.props.onRolesChange(this.state);
  }

  handleNumberChange(event) {
    const oldValue = this.state.number;
    const newValue = event.target.value.trim();
    const phChange = calculatePhoneNumberChange(oldValue, newValue);
    if (phChange.shouldUpdate) {
      this.setState({ number: phChange.newValue }, this.reportNumberChange);
    }
  }

  reportNumberChange() {
    this.props.onNumberChange(this.state.number);
  }

  render() {
    const { classes, required, label, possibleRoles, onMouseDownInEditableArea } = this.props;
    return (
      <div className={classes.phoneInput}>
        <div className={required ? classes.phoneInputLabel_rqd : classes.phoneInputLabel}>{label}</div>
        <div className={classes.labelsAndNumberDiv}>
          <div className={classes.rolesRow}>
            <FormGroup row>
              {possibleRoles.map((roleName) => (
                <FormControlLabel
                  key={roleName}
                  className={classes.checkBoxStyle}
                  name={roleName}
                  control={
                    <Checkbox
                      checked={this.state[roleName]}
                      onChange={(event) => this.handleCheckboxChange(event)}
                      onClick={onMouseDownInEditableArea}
                      value={roleName}
                      color="primary"
                    />
                  }
                  label={<span className={classes.checkboxLabel}>{roleName}</span>}
                />
              ))}
            </FormGroup>
          </div>
          <div className={classes.numberInput}>
            <Input
              className={classes.nativeInput}
              value={this.state.number}
              onChange={(event) => this.handleNumberChange(event)}
              onClick={onMouseDownInEditableArea}
              placeholder="(213) 555-1212"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(phoneInputStyle)(PhoneInput);
